/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from "@glimmer/component";
import type Patient from "parog-web/models/patient";
import type PredictorExplainer from "parog-web/models/predictor/predictor-explainer";

interface Signature {
  Args: {
    patient: Patient;
  };
}

export default class ObservancePredictionScoreResultPageComponent extends Component<Signature> {
  get observanceExplainers(): PredictorExplainer[] | undefined {
    return this.args.patient.adherencePredictionComputedJournalEvent?.[
      "observanceExplainers"
    ];
  }

  get observanceScoreDistributionExplainer(): PredictorExplainer | undefined {
    return this.observanceExplainers?.find(
      explainer => explainer.explainerType === "score_distribution_plot"
    );
  }

  get observanceShapBarExplainer(): PredictorExplainer | undefined {
    return this.observanceExplainers?.find(
      explainer => explainer.explainerType === "explainer_bar_chart"
    );
  }
}
